import axios from 'axios';
import { authHeader } from './utils';
import {
  GET_USER,
  LIST_USER,
  LOGIN_USER_FAILURE,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAILURE,
} from './types';
import { removeLocalStorageAuth, setLocalStorageAuth } from './auth';

export const getUser = (id) => async (dispatch) => {
  const res = await axios.get(`/api/users/${id}`, {
    headers: authHeader(),
  });
  console.log('res', res.data);
  dispatch({ type: GET_USER, payload: res.data.user });
};

export const fetchUsers =
  ({ page, limit }) =>
  async (dispatch) => {
    const res = await axios.get('/api/users', {
      headers: authHeader(),
      params: { page, limit },
    });
    dispatch({ type: LIST_USER, payload: res.data });
  };

export const submitUser =
  ({ user }, navigate) =>
  async (dispatch) => {
    const res = await axios.post('/api/users', user, {
      headers: authHeader(),
    });
    navigate('/users');
    // dispatch({ type: GET_USER, payload: {} });
  };

export const updateUser =
  ({ user, id }, navigate) =>
  async (dispatch) => {
    console.log('user', user);
    console.log('id', id);
    const res = await axios.put(`/api/users/${id}`, user, {
      headers: authHeader(),
    });
    navigate('/users');
    // dispatch({ type: LIST_USER, payload: [] });
  };

export const patchUser =
  ({ user, id }, navigate) =>
  async (dispatch) => {
    const res = await axios.patch(`/api/users/${id}`, user, {
      headers: authHeader(),
    });
    // navigate("/users");
  };

export const deleteUser =
  ({ id }, navigate) =>
  async (dispatch) => {
    try {
      const res = await axios.delete(`/api/users/${id}`, {
        headers: authHeader(),
      });
      navigate('/users');
      // dispatch({ type: LIST_USER, payload: [] });
    } catch (error) {
      console.log(error);
    }
  };

export const loginUser =
  ({ username, password }) =>
  async (dispatch) => {
    try {
      const res = await axios.post('/api/users/login', {
        username,
        password,
      });
      console.log(res.data);
      dispatch({ type: LOGIN_USER_SUCCESS, payload: res.data });
    } catch (error) {
      dispatch({
        type: LOGIN_USER_FAILURE,
        error: error.response,
      });
      // return error;
    }
  };

export const logoutUser = () => async (dispatch) => {
  try {
    const res = await axios.post(
      '/api/users/logout',
      {},
      {
        headers: authHeader(),
      }
    );
    dispatch({ type: LOGOUT_USER_SUCCESS, payload: res.data });
  } catch (error) {
    console.log('error in logoutUser', error);
    dispatch({
      type: LOGOUT_USER_FAILURE,
      error: error.response,
    });
    // } finally {
    //   dispatch(removeLocalStorageAuth());
    //   navigate('/');
  }
};

export const syncUser = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/users/${id}`, {
      headers: authHeader(),
    });
    console.log('res', res.data);
    // dispatch({ type: UPDATE_USER, payload: res.data });
    dispatch(setLocalStorageAuth(res.data));
    // dispatch(updateLocalStorageAuth(res.data));
  } catch (error) {
    console.log('error in syncUser', error);
  }
};
